export default __webpack_public_path__ + "static/media/tel.251969a7.svg";